import { useMutation, useQueryClient } from '@tanstack/react-query';
import _ from 'lodash';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

export const useCreateWallet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await request({
        path: 'declarant/create-wallet',
        method: 'POST',
        authenticate: true,
        dataObject: {},
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
      toast.success('Wallet created successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error creating the wallet!`);
    },
  });
};
